const CoordinatorDesk = () => {
    return (
        <div id="coordinator" className="about-message container">
            <div className="message-left">
                <img src="https://picsum.photos/300/352" alt="coordinator" />
            </div>

            <div className="message-right">
                <h2>COORDINATOR'S DESK</h2>
                <p>
                    We ensure smooth academic planning, student support, and balanced
                    co-curricular development.
                </p>
                <h4>- Coordinator -</h4>
            </div>
        </div>
    );
};

export default CoordinatorDesk;